module.exports = __webpack_public_path__ + "img/user.8f200019.svg";